module.exports = __webpack_public_path__ + "static/media/service_all_star.9973aa27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badges/service_all_star.png
// module id = 1067
// module chunks = 0